import { createPatchAsyncSlice } from '@sonar-software/xuder';
import { getCoreDataSecurityMonitorsSlice } from '../get';
import { updateCoreDataSecurityMonitorsByApplicationSyncSlice } from '../application/update';
import { updateCoreDataSecurityMonitorsSyncSlice } from '../update';

import { muteDataSecurityMonitorById, MuteDataSecurityMonitorByIdRequest } from '@api/data-security';

export const muteCoreDataSecurityMonitorsSlice = createPatchAsyncSlice<
	'MuteCoreDataSecurityMonitorsById',
	MuteDataSecurityMonitorByIdRequest
>({
	httpSagaOptions: {
		preRequestActionCreators: [
			updateCoreDataSecurityMonitorsSyncSlice.syncActionCreator
		],
		successActionCreators: [
			getCoreDataSecurityMonitorsSlice.asyncActionCreators.repeatGetCoreDataSecurityMonitors
		],
		successCombinationActionCreators: [
			updateCoreDataSecurityMonitorsByApplicationSyncSlice.syncActionCreator
		]
	},
	name: 'MuteCoreDataSecurityMonitorsById',
	receive: false,
	request: true,
	requestHandler: muteDataSecurityMonitorById
});
